export default {
  header: {
    index: 'Home',
    hotel: 'Hotel',
    ticket: 'Ticket',
    tour: 'Tour',
    user: 'User',
    yl: 'Cruise',
    gntp: 'Package'
  },
  tplist: {
    sstp: 'Search Package',
    zdzh: 'Look for your package',
    qsrt: 'Package keyword',
    ydrq: 'Select date',
    xzqy: 'Select region',
    ss: 'Search',
    jxtp: 'Traveler‘s picks',
    fxzs: 'Discover the best travel experience',
    ckxq: 'Read Details',
    rmmd: 'Top destination',
    sscf: 'Book for now',
    q: 'up',
    ljyd: 'Book now',
    zwtp: 'No Matching Result',
    zsmy: 'My apologies, but no matching package were found.',
    cxjz: 'Reload',
    hk: 'Hong Kong',
    am: 'Macau',
    dl: 'China',
    tw: 'Taiwan',
    hw: 'Overseas',
    loading: 'Loading...',
    loadFailed: 'Image load failed'
  },
  tpdetail: {
    qf: 'pax',
    xzfj: 'Select additional products',
    tpne: 'Package details',
    zkqb: 'See more',
    qb: 'All',
    fybh: 'What‘s included',
    dqrq: 'Unavilable',
    grqz: 'Unavilable for selected date',
    xzrq: 'Select date',
    ytdg: 'Select more experience to get the best deal!',
    txgd: 'Click here to add more',
    qcsy: 'Clear all',
    tpje: 'Supplement',
    jd: 'Hotel Details',
    ddyd: 'Booking only',
    xj: 'Stars',
    fx: 'Room type',
    jdss: 'Room details',
    rssx: 'Capacity',
    zd: 'Up to',
    r: 'pax',
    d: 'Adult',
    x: 'Kid',
    mp: 'Ticket',
    ydxz: 'What you need to know',
    cpxq: 'Product Details',
    cq: 'Meal Coupon',
    bc: 'Charter service',
    dy: 'Itinerary',
    qtcp: 'More ',
    fhcp: 'Back to product list ',
    zzjs: 'loading',
    zzjz: 'Loading',
    hy: 'and',
    qx: 'chanel',
    jdzs: 'Hotel',
    jdmc: 'Hotel name',
    fxmc: 'Room type',
    h: 'included',
    fzc: 'breakfasts',
    bhz: 'N/A Breakfast',
    j: 'room',
    w: 'night',
    syrq: 'Selected date',
    sl: 'Qty',
    fjcp: 'Add on product',
    hjzj: 'Total',
    xyb: 'Reserve now',
    tpsl: 'Package Qty',
    gqsh: 'Loading',
    tpyd: 'Terms & Conditions',
    zdl: 'Got it',
    cqmp: 'Meal Voucher / Ticket',
    tpxq: 'Package Details',
    gxx: 'Options',
    qd: 'Confirm',
    jzz: 'Loading...',
    qdsc: 'Are you sure you want to delete this additional product?',
    qdqc: 'Are you sure you want to clear all additional products?',
    crzj: 'No price available for this date',
    zj: 'No price available',
    crzjqxtrq: 'No price available for this date, please select another date',
    tpnrzjqxtrq: 'Package content has no price, please select another date',
    crzjqxtrq2: 'No price available for this date, please select another date',
    tpnrzjqxtrq2: 'Package content has no price, please select another date',
    tpnrzjwbyd: 'Package content has no price, cannot book',
    zjqkzql: 'No price available, quantity automatically cleared',
    crzjqkzql: 'No price available for this date, please reselect',
    z: 'pax',
    // Breakfast information translations
    noBreakfast: 'No Breakfast',
    breakfast1: '1 Breakfast',
    breakfast2: '2 Breakfasts',
    breakfastCount: '{count} Breakfasts',

    // Error messages
    completeAddOnSettings: 'Please complete add-on product settings or click "Clear All" to remove incomplete add-on products',
    hotelNotAvailable: 'Hotel portion not available',
    ticketNotAvailable: 'Ticket portion not available',
    packageNotAvailable: 'Package not available for current date',
    bookingConditionsNotMet: 'Booking conditions not met, please check selected content',
    bookingConditionsNotMetNoJump: 'Booking conditions not met, cannot proceed',
    productUnavailableForDate: 'Product temporarily unavailable for this date',
    productUnavailableForDateMessage: 'Product temporarily unavailable for this date, please select another date'
  },
  tporder: {
    tpne: 'Product Name',
    zkqb: 'Quantity',
    fybh: 'Selected Date',
    dqrq: 'Price Details',
    xzrq: 'Co',
    wlbh: 'Click for package details',
    txgd: 'Hotel name',
    qcsy: 'Ticket',
    crzw: 'Qty',
    tpje: 'Supplement fee',
    jd: 'Co',
    ckfj: 'View additional products',
    ddyd: 'Add on product',
    zxzf: 'Pay Now',
    fj: 'Add new guest (optional)',
    jdss: 'Guest',
    rssx: 'Surname',
    zd: 'Only English Letter',
    d: 'Given Name',
    x: 'Only English Letter',
    mp: 'Gender',
    bkd: 'Choose Gender',
    ydxz: 'Male',
    cpxq: 'Female',
    z: 'The property will do its best, but cannot guarantee to fulfil all requests.',
    tpmc: 'Package Name',
    ydsl: 'Booking Quantity',
    syrq: 'Usage Date',
    jgxq: 'Price Details',
    tpsl: 'Package Quantity',
    jdzs: 'Hotel Accommodation',
    mpjd: 'Ticket Attractions',
    qtcp2: 'Other Products',
    rscb: 'Person Supplement Price',
    fjcp: 'Add-ons',
    zxzf2: 'Online Payment',
    xzyk: 'Add Tourist',
    yk: 'Tourist',
    xs: 'Last Name',
    qsrxs: 'Please enter last name',
    mz: 'First Name',
    qsrmz: 'Please enter first name',
    xb: 'Gender',
    qxzxb: 'Please select gender',
    n: 'Male',
    nv: 'Female',
    bzxx: 'Remarks',
    fhcp2: 'Return to Product List',
    gb: 'Close',
    zdyk: 'At least 1 tourist must be retained',
    zwydxz: 'No booking notice information available',
    zwcpxq: 'No product detail information available',
    tpxq: 'Package Details',
    ydxz2: 'Booking Notice',
    cpxq2: 'Product Details',
    hj: 'Total'
  },
  gntp: {
    sycp: 'All Products',
    mpjd: 'Attractions',
    jdtp: 'Hotel Package',
    ddms: 'Meal Voucher',
    ddhqc: 'Local Hotspots',
    splb: 'Category',
    dq: 'Region',
    gjz: 'Keyword',
    ss: 'Search',
    hpl: 'Favorable Rate',
    ydts: 'Booking Tips',
    xzcp: 'Select Product',
    ecqr: 'Second Confirmation is required as offering from the third party。',
    jjqg: 'Book Now',
    cpjs: 'Product Description',
    jtxl: 'Transportation'
  },
  util: {
    Agreement: 'Agreement',
    ljcz: 'Reset Now',
    yzm: 'Verify Code',
    fsyzm: 'Verify',
    qsryzm: 'Code Insert',
    yyzh: 'Login',
    ljzc: 'Register now',
    jrwm: 'Join HUAYI',
    zdj: 'Lowest Price',
    q: 'From',
    jrck: 'Clink & Check',
    cfd: 'From',
    cfrq: 'Departure Date',
    xcts: 'Duration',
    mddgjz: 'Destination/Keyword',
    mdd: 'Destination',
    rzrq: 'Check in Date',
    w: 'Night',
    ldrq: 'Check Out Date',
    fjzks: 'Room & Pax',
    fjs: 'Number of Rooms',
    crs: 'Adult',
    ets: 'Child',
    qd: 'Confirm',
    j: 'Room',
    cr: 'Adult',
    xt: 'Child',
    ss: 'Search',
    jdxj: 'Hotel Star Rate',
    ywrq: 'Date Of Use',
    z: 'WeekS',
    pjmwbhsj: ' Price Per Night W/T Tax)',
    drysw: 'Sold Out',
    ck: 'Check',
    dg: 'Book',
    dz: 'Address',
    bz: 'Currency',
    zhyb: 'Last Step',
    ydxq: 'Booking Description',
    yxjd: 'Selected Hotel',
    yxcp: 'Selected Product',
    llwm: 'Contact Us',
    bqsy: 'Copyright',
    yysjyw: 'Please Call After Business Hours',
    yysj: 'Business Hour',
    rjkfdh: 'Day Time Operating Duty',
    khfwzy: 'Customer Service Support',
    lxwm: 'Contact Us',
    mee: 'MEE美意 APP',
    gywm: 'ABOUT US',
    zzjzgd: 'Buffering',
    wsydx: 'Bottom Line',
    htgdsfzhdr: 'Login via third party',
    wjmm: 'Forget Passpord',
    myzh: 'New? Get Registered',
    ljdl: 'Login',
    ystk: 'Privacy Policy',
    tkxz: 'Term & Condition',
    khdl: 'Login',
    thdl: 'B2B Login',
    yhm: 'User Nmae',
    yhmdesc: 'Please insert your user name',
    mm: 'Password',
    mmdesc: 'Please insert your password',
    ty: 'Agree',
    qxtytkxz: 'Please read and agree to the agreement',
    wddd: 'My Booking',
    tcdl: 'Logout',
    drhqhyzg: 'Login for discounts',
    drhzc: 'Login or Register',
    ydjc: 'Scheduled Detection',
    qxdl: 'Please Login',
    gxn: 'Congrats! You’ve got the best deal!',
    hyh: 'Sold out Sorry!',
    J: 'Jan',
    F: 'Feb',
    M: 'Mar',
    A: 'Apr',
    May: 'May',
    June: 'June',
    July: 'July',
    Au: 'Aug',
    S: 'Sept',
    O: 'Oct',
    N: 'Nov',
    D: 'Dec'
  },
  index: {
    slogan: '千里之行 始于华逸',
    jdyd: 'Hotel',
    djtp: 'Package',
    mscj: 'Meal Vouchers',
    jdmp: 'Attraction',
    gty: 'Tour Travel',
    hwsdy: 'Deep Outdoor Tour',
    hwly: 'Camping Outdoors',
    wqdj: 'Hotel Spring',
    appTitle: 'Follow Me To The World',
    appDesc: 'Easy to book your travel essentials 。',
    hzhb: 'Business Partner',
    hzhbdesc: 'HUAYI TRAVEL In order to enhance the best travel experience, we cooperate with diversified travel partner. ',
    jdtj: 'Top Sale Hotel',
    zwcp: 'More to Come',
    cjtj: 'F&B Vouchers',
    ddwl: 'Attractions',
    rmxc: 'Top Sale Tour',
    rm: 'HOT',
    gat: 'Great Bay Area',
    gn: 'China',
    dny: 'SEA',
    az: 'AUSTRALIA',
    oz: 'EUROPE',
    tp: 'Package',
    xg: 'HONG KONG',
    am: 'MACAU',
    zyx: 'Independent Travel',
    xl: 'Itinerary',
    rb: 'JAPAN',
    jd: 'Hotel'
  },
  cruise: {
    yl: 'Cruise',
    bz: 'Type',
    bh: 'Referenece No.',
    mc: 'Name',
    xc: 'Route',
    cfrq: 'Departure Date',
    ljbl: 'Apply Now'
  },
  hotel: {
    bhs: 'The discounted price does not include taxes and fees related to invoicing, if applicable.',
    jjd: 'Hotels',
    gzd: 'Find a Total of ',
    yfdsjbdpf: 'Due to the frequent price fluctuations of the hotel, the actual amount payable is subject to the establishment of the order',
    pjmwhsj: 'Price Per Night inc Tax',
    exj: '2 Stars or below/Economy',
    snxj: '3 Stars/Cozy',
    sxj: '4 Stars/Deluxe',
    wxj: '5 Stars/Luxury',
    xj: 'Star',
    ljqr: ' Instant Confirmation',
    tp: 'Package',
    hzc: 'Breakfast Included',
    rmsx: 'Filter',
    xsdt: 'Map',
    ss: 'Search',
    et: 'Child',
    cr: 'Adult',
    qd: 'Confirm',
    ets: 'Child',
    crs: 'Adult',
    fjs: 'Room',
    fjsjrs: 'Room & Pax',
    w: 'Night',
    ldrq: 'Check Out Date',
    rzrq: 'Check In Date',
    mdd: 'Destination/Keyword ',
    zwcxdfx: 'N/A',
    zyzx: 'Important Information',
    jqld: 'Highlight Point',
    jdjs: 'Hotel description',
    z: '张',
    hj: 'Total',
    wzc: 'Breakfast',
    h: 'Include',
    bhz: 'Exclude Breakfast',
    gxsjh: 'Sales Plan',
    zsew: 'Show More',
    yc: 'Hide',
    yd: 'Book Now',
    bhsjfwf: 'Exclude Tax & Service Fee',
    xsyh: 'Limited Offer',
    bnqx: 'No Cancellation',
    gatzx: 'Exclusive to HK & MAC & TW',
    ydts: 'Booking Tips',
    pjmfmwjg: 'Price Per Night',
    xgzc: 'Related Policy',
    mc: 'Name',
    zxzf: 'Online Payment',
    j: 'Room',
    jgxq: 'Price Details',
    fh: 'Back',
    tjcddjbsnyydbty: 'Submitting this booking indicates that you’ve read and agreed with the privacy policy and T&C of HUAYI TRAVEL。',
    xybzhqr: ' Next Step: Final Confirmation ',
    czsjjzdnl: 'All the remarks subject to the accurate situation of hotel.',
    xt: '（Optional）',
    tsyq: ' Special Remark',
    dl: 'China 86',
    am: 'Macau 853',
    xg: 'Hong Kong 852',
    jyykhfw: 'Customer Service Only',
    qsrzqdhhm: 'Please Insert the Phone Number',
    dhhm: 'Phone No.',
    yyjsqryj: 'For receiving the email',
    qsrzqyxdz: ' Email Address',
    qsryxdz: 'Email Address ',
    dy: 'Email',
    gajdqtyw: 'HK & MAC& Overseas Hotel Please fill in English or Pinyin',
    mzdesc: 'Given Name',
    mz: 'Given Name',
    xsdesc: 'Surname',
    xs: 'Surname',
    xzzk: 'New Guests (Optional)',
    fj: 'Rooms',
    rkzldesc: 'Please ensure that the guest name is the same as the valid ID used at check-in',
    zkzl: 'Check in Guest Info',
    gmsl: 'Purchase Quantity',
    dj: 'Unit Price',
    fjcp: 'Add On',
    tyd: 'Days ',
    xtq: 'Book In advance',
    rzts: 'Days',
    zao: 'Breakfast',
    zcsl: 'Breakfasts',
    etnl: 'Child Age',
    mfjrzet: 'Children Per Room',
    mfjrzcr: 'Adult Per Room',
    mfjzdrz: 'Maximum Occupancy Per Room',
    fx: 'Room Type',
    xsjh: 'Sales Plan',
    dz: 'Address',
    qsrdhhm: 'Phone Number',
    ts: 'Alert',
    djrl: 'Low Price Calendar (lowest price on the day)',
    tf: ' Check-in and Check-out time is the local time of the hotel.',
    bz: 'Currency',
    night: 'Night',
    Sun: 'Sun',
    Mon: 'Mon',
    Tus: 'Tus',
    Wes: 'Wes',
    Thur: 'Thur',
    Fri: 'Fri',
    Sat: 'Sat',
    Year: 'Year',
    Month: 'Month',
    one: 'Mon',
    two: 'Tus',
    three: 'Wes',
    four: 'Thur',
    five: 'Fri',
    six: 'Sat',
    seven: 'Sun',
    day: 'Day',
    ROO: 'per room'

  },
  tour: {
    qrww: 'Confirm',
    qx: 'Cancel',
    tkzc: 'T&C',
    zj: 'ID Information',
    csrq: 'Date of Birth',
    xb: 'Gender',
    yx: 'Email',
    dh: 'Tel',
    xm: 'Name',
    bc: 'Difference',
    ye: 'Infant',
    etbzc: 'Child W/T Bed',
    et: 'Child',
    cr: 'Adult',
    cf: 'Departure',
    fc: 'Arrival',
    qecqryxxx: 'Please confirm the following information twice',
    xcjs: 'Tour Description',
    fybh: 'Price Including',
    zfxm: 'Exclusive Item',
    tbtx: 'Special Reminder',
    fyxz: 'Payment Details',
    xzxc: 'PDF Download',
    wqts: 'Friendly Reminder',
    bjbz: 'Currency',
    xcwd: 'PDF Itinerary',
    jhd: 'Assemble',
    rqxz: 'Crowd Restriction',
    hyly: 'HUAYI TRAVEL',
    qglm: 'National Alliance',
    tj: 'Recommend+',
    jrck: 'Check',
    ljyd: 'Book Now',
    cfrq: 'Departure Date',
    xt: 'Child',
    zc: 'With Bed',
    bzc: 'N/A Bed',
    ze: 'Total',
    xtzc: 'Child With Bed',
    xtbzc: 'Child W/T Bed',
    ksyd: 'Book Now',
    ywzt: 'Theme',
    zyx: 'Independent Travel',
    gty: 'Tour Travel',
    bx: 'Unlimited',
    lx: 'Type',
    mdd: 'Destination',
    ss: 'Search',
    qsrmddjdgjz: 'Destination/Attraction/Keyword/Ref. Number',
    cfd: 'Departure From',
    drbc: 'Make up the price gap',
    sfz: 'ID CARD ',
    hz: 'Passport',
    gahxz: 'Home Return Permit(HRP)',
    tbz: 'Mainland Travel Permit for Taiwan Residents',
    qt: 'Otters',
    ts: 'Days',
    hcrq: 'Date of Return',
    ykzl: 'Tourist Information',
    xs: 'Surname',
    qsrxs: 'Please Insert the Surname',
    mz: 'Given Name',
    qsrmz: 'Nmae',
    qsrdh: 'Contact No.',
    qsryx: 'Email',
    qxzxb: 'Gender',
    qsrcsrq: 'Date of Birth',
    qsrzj: 'Identity',
    qxz: 'Choose',
    dy: 'Email',
    qsryxdz: 'Email',
    qsrzqyx: 'Email',
    yyjsqryj: 'To Receive The Confirmation Letter',
    dhhm: 'Contact No.',
    qsrdhhm: 'Contact No.',
    qsrzqdhhm: 'Contact No.',
    jyykhfw: 'Customer Service Only',
    xg: 'HONG KONG 852',
    am: 'MACAU 853',
    dl: 'CHINA 86',
    tsyq: 'Special Request',
    xuantian: '（Optional）',
    tjcddbsnyydbty: 'Submitting this booking indicates you‘ve read and agreed with the T&B of HUAYI TRAVEL LIMITED.',
    xybzhqr: 'Next Step: Final Confirmation',
    fh: 'Back',
    jgxq: 'Price Details',
    hj: 'TOTAL',
    zxzf: 'Pay Online',
    xxzf: 'Pay Offline'
  },
  ticket: {
    hj: 'Total',
    z: '張',
    zdj: 'The Best Deal',
    xzsl: 'Choose',
    xz: 'Choose',
    qxxz: 'Deselect',
    q: 'From',
    ljgm: 'Book Now',
    qxzcp: 'Select Product',
    dj: 'Unit/Price ',
    cp: 'Product',
    g: '个',
    xqjs: 'Description',
    ydts: 'Booking Alert',
    zwcp: 'No Result',
    xzfa: 'Choose Plan',
    xzrq: 'Pick the Date',
    hdfl: 'Categorize',
    mpjd: 'Attraction',
    mscj: 'F&B Vouchers',
    mbqy: 'Region',
    gzd: 'Found',
    gjz: 'Keyword',
    jgfw: 'Price Range',
    qd: 'Confirm',
    ksqr: 'Instant Confirm',
    gzsjn: 'Will confirm within 3 hours during working day ',
    ydrq: 'Reserved Date',
    dz: 'Address',
    xj: 'Sum up',
    fhxg: 'Back to Edit',
    ykxx: 'Tourist Info',
    yk: 'Tourist',
    xm: 'Name',
    qsrxm: 'Accurate Name',
    sj: 'Contact No.',
    qsrsj: 'Contact No.',
    ywm: 'English Name',
    qsrywm: 'English Name',
    qsryx: 'Email',
    yx: 'Email',
    zj: 'Identity',
    qsrzj: 'Identity',
    qsremail: 'Email',
    lldh: 'Contact No.',
    qsrlxdh: 'Contact No.',
    xg: 'HONG KONG 852',
    am: 'MACAU 853',
    dl: 'CHINA 86',
    bz: 'Remark ',
    cddyydty: 'Submitting this booking indicates you’ve read and agreed with the T&B of HUAYI TRAVEL LIMITED,',
    xyb: 'Next Step: Final Confirmation',
    pjyjscbtbg: 'No Change or Refund after confirmation.',
    ydtx: 'Booking Reminder',
    djrl: 'Price Calendar',
    zwbj: 'N/A （not available）',
    jgrl: 'Price Calendar'
  },
  specialEvent: {
    dh: 'Tel',
    cz: 'Fax',
    kfsj: 'Open Hour',
    bz: 'Remark',
    sf: 'Charge',
    hdyf: 'Date of Event',
    dz: 'Address',
    gjd: 'Scenic Spot',
    macau: {
      am: 'MACAU',
      tsamszw: 'Don’t miss out the secret spot in Macau',
      myswt: 'Food is of Primary Importance to the people.',
      myswtdesc: 'Travel like a local? Don‘t miss out the secret spot in Macau',
      jwzbh: 'Where to stay tonight?',
      jwzbhdesc: 'Discover the most popular accommodation in Macau and more special offer.',
      ck: 'Check',
      wlhqc: 'Fun Places To Go',
      wlhqcdesc: 'What are the recommended activities in Macau? From unmissable sights to the places where locals love to hang out, we have the latest information on everything you need.',
      ddhd: 'Local Event',
      ddhddesc: 'Local Events of the Month.',
      hdrq: 'Date of Event'
    },
    package: {
      zs: 'Hotel',
      mp: 'Ticketing'
    },
    oloq: {
      ozxhtdesc: '8 European itineraries, cycling weekly, visiting 75 cities in 22 countries! European local groups, hop on hop off, guaranteed departure year round!',
      ozxht: 'Europe Circular Tour',
      oloqtdesc: 'Since its inception in 2005, more than 200,000 people have participated in it every year.',
      oloqt: 'Europe Circular Tour Route Map'
    },
    chimelong: {
      gzcl: 'GuangZhou Chimelong',
      zhcl: 'ZhuHai Chimelong',
      jd: ' Seasonal Top Sale - Hotel',
      mp: 'Seasonal Top Sale - Ticketing'
    },
    disney: {
      ljqwyd: 'Book now',
      hxdesc: 'Dash in and out of twisting caverns and rumble through Grizzly Gulch aboard a speeding mine train.Venture inside the Big Grizzly Mountain Mining Company building, erected in the early days of California’s Gold Rush. Amid flickering kerosene lanterns, wander past a dusty sawmill, rusty prospectors’ lockers and the cluttered workshop of the chief geologist before boarding a mysterious mine car waiting to take you on an excursion inside the old mountain.',
      hx: 'Big Grizzly Mountain Runaway Mine Cars',
      szdesc: 'Swing into jungle fun with acrobats and fire dancers as Simba, Timon and Pumbaa come to life in a musical extravaganza. Presented in Theater in the Wild.',
      sz: 'Festival of The Lion King',
      mfswdesc: '“A spectacularly unique “Happily Ever After” show has been created to bring to life new and classic Disney stories and movies in an exhilarating, musical revue stage production like no other! Presented in Disney‘s Storybook Theater.',
      mfsw: 'Mickey and the Wondrous Book',
      tjqxDesc: 'One of the world’s greatest super heroes is among us and Hong Kong will never be the same. Iron Man Experience - the first ever Marvel themed ride to feature at a Disney theme park, now opens at Hong Kong Disneyland!',
      tjqx: 'Iron Man Experience - Presented by AIA',
      hgndesc: 'Spin around, up and down to joyous music atop a regal steed at this classic attraction inspired by Disney’s Cinderella.',
      hgn: 'Cinderella Carousel',
      xmgzldesc: '“Momentous” will delight your senses with spectacular multimedia elements, including large scale 3D projection mapping technology, choreographed fountains, illuminated water projection, lasers, theatrical lighting, pyrotechnics, and fireworks effects. What’s more, your ears will be regaled with newly-reimagined classic Disney songs. It’s a spellbinding experience that’s sure to melt hearts, warm smiles, and reawaken beloved memories.',
      xmgzl: 'Hong Kong Disneyland "Momentous"',
      ylbydesc: 'Complete your Disney experience with a range of exciting and irresistible activities.',
      ylby: 'Don’t Miss the Attractions and Entertainment Ahows',
      zwcxdfj: 'No Result',
      fj: 'Room',
      cr: 'Adult',
      et: 'Child',
      qd: 'Confirm',
      ets: 'Child',
      crs: 'Adult',
      fjs: 'Rooms ',
      dsndmhqf: 'Fantastic Atmosphere of Disney',
      zjdsnjdgs: 'In Disney‘s classic story, live your own story.',
      ckxq: 'Booking Details',
      lyjd: 'Hong Kong Disneyland Hotel',
      hlwjd: 'Hong Kong Disney Hollywood Hotel',
      dyweddjjd: 'The Unique Hotel Destination.'
    }
  },
  user: {
    jmm: 'Old Password',
    xmm: 'New Passowrd',
    bc: 'Save',
    xm: 'Name',
    dzyj: 'Email',
    lxdh: 'Contact No.',
    dc: 'Export To',
    sjkx: 'Exact Payment',
    fhkx: 'Refund Payment',
    ykkx: 'Deduct Payment',
    yxdd: 'Valid Booking',
    qxdd: 'Cancelled Booking',
    hjdd: 'Total Orders',
    ssxt: 'Refer System',
    xdrq: 'Booking Date',
    syed: 'Usage Limit',
    cpxx: 'Product Info',
    ddbh: 'Booking Reference',
    cx: 'Inquire',
    js: 'Finish',
    ks: 'Begin',
    z: 'To',
    rzrq: 'Check In Date',
    ldrq: 'Check Out Date',
    yqx: 'Cancelled',
    yzf: 'Paid',
    wzf: 'Payment Pending',
    bx: 'Unlimited',
    ddzt: 'Booking Status',
    jd: 'Hotel',
    pw: 'Ticketing',
    ddlx: 'Booking Type',
    lvxm: 'Name of Tourist',
    syyck: 'Pre-payment Remaining',
    syued: 'Credit Remaining ',
    am: 'MACAU',
    xg: 'HONG KONG',
    lkbxg: 'BLANK',
    mm: 'Password',
    qsrdh: 'Contact No.',
    dh: 'Contact No.',
    qsryhm: 'User Name',
    yhm: 'User Name',
    qsrxm: 'Name',
    xiugai: 'Amend',
    qy: 'Active',
    jy: 'Disable',
    cz: 'Operate',
    zc: 'Normal',
    ty: 'Suspended',
    zt: 'Status',
    yj: 'Email',
    dlzh: 'Login',
    tj: 'Add',
    qsrmm: 'Password',
    jianshu: 'Rooms',
    ddje: 'Booking Amount',
    bzxx: 'Remark',
    dzf: 'Payment Pending',
    zkxx: 'Check-in Guest Details',
    qrh: 'Confirmation No.',
    lldh: 'Contact No.',
    llyx: 'Email',
    ykxx: 'Tourist Info',
    qt: 'Others',
    tbz: 'Mainland Travel Permit for Taiwan Residents',
    gahxz: 'Home Return Permit',
    hz: 'Passaport',
    sfz: 'ID CARD',
    yx: 'Email',
    sj: 'Contact No.',
    zj: 'ID CARD',
    csrq: 'Date of Birth',
    xb: 'Gender',
    rs: 'Number of People',
    cfrq: 'Departure Date',
    zcyd: 'Book again',
    fk: 'Pay',
    ksxz: 'Guest Info',
    j: 'Room',
    w: 'Night',
    ywrq: 'Entry Date',
    krxx: 'Guest Information ',
    cxrq: 'Travel Date',
    ydrq: 'Booking Date',
    hy: 'Membership',
    hzhb: 'Business Partner',
    ddlb: 'Booking List',
    qb: 'ALL',
    xl: 'TOUR',
    grzl: 'Personal Information ',
    zhjmm: 'Account & PW',
    zzh: 'Sub Account',
    zh: 'Account',
    cwxx: 'Financial Information',
    edxx: 'Credit Info',
    zcsrmm: 'Enter Password Again',
    mmbnwk: 'Password cannot be empty',
    dqsxfwwdd: 'No Result were found.',
    ljqw: 'Go Now',
    ydj: 'Book',
    ss: 'Search',
    lcsrmmbyz: 'Password not match'
  },
  pay: {
    PaymentList: {
      mpay: 'MPay',
      wechat: 'WeChat Pay',
      alipay: 'Alipay Pay',
      offline: 'Offline Payment',
      quota: 'Pay by Credit',
      MPayDesc: 'MOP Recommend for Mpay user(MOP)',
      wechatDesc: 'Recommend for CHINA user(CNY)',
      alipayDesc: 'Recommend for CHINA user(CNY)',
      offlineDesc: 'Bank Transfer is also welcome for users in Hong Kong or B2B',
      quotaDesc: 'Top-Up Credit for B2B Users'
    },
    qy: 'Please Within',
    nzfdd: ' Pay Order',
    fkfs: 'Payment Method',
    ljzf: 'Pay Now',
    fksb: 'Pay Failed',
    fkcg: 'Paid Successfully',
    zfcg: 'Paid Successfully, Back to HOME',
    zfsb: 'Paid Failed, Back to Previous Page',
    ddbh: 'Booking Reference',
    xszf: 'Pay Online',
    rz: 'Check In',
    ld: 'Check Out',
    js: 'Rooms',
    ywrq: 'Outing Date',
    sl: 'Quantity',
    cpmc: 'Product Name',
    cxrq: 'Reserved Date',
    bstk: 'No Refund',
    ddqrhbkqxhgg: 'No Cancellation or Refund after confirmation. ',
    hztvjbgxaqfsw: '：Your safety is our first priority, HUAYI TRAVEL is authorised by the following safety institutes.'
  },
  // Weekday translations - 移到根级别，首字母大写
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday'
}



// WEBPACK FOOTER //
// ./src/lang/en.js